<nav>
  @if (noSection()) {
    <ng-container *ngTemplateOutlet="stepsTemplate; context: { steps: steps() }" />
  } @else {
    @for (section of sections(); track section.id) {
      <div class="section">
        <p class="caption-xs label">
          {{ section.title | translate }}
          <ng-container *ngTemplateOutlet="stepsTemplate; context: { steps: section.steps }" />
        </p>
      </div>
    }
  }
</nav>

<ng-template #stepsTemplate let-steps="steps">
  @for (step of steps; track step) {
    @if (menuItemComponentsMapping()[step]; as component) {
      <div class="item">
        <ng-container *ngComponentOutlet="component" />
      </div>
    }
  }
</ng-template>
